"use strict";
exports.__esModule = true;
exports.EMBED_DELAYED_LOADING = void 0;
exports.EMBED_DELAYED_LOADING = {
    HEADER: 'Hang tight!',
    BODY: 'Please keep this page open while we process your rent.',
    NOTICE: 'This may take a few minutes.'
};
